import { Mutations } from '../mutations.enum';
import { CompanyAttachment } from '../../entities/system-global.entity';

export default {
  setCompanyData({ commit }: any, company: CompanyAttachment) {
    commit(Mutations.SET_COMPANY_DATA, company);
  },
};
